// 📁 middleware/auth.global.ts
import { useAuthStore } from '~/stores/auth/useAuthStore'

export default defineNuxtRouteMiddleware(async (to) => {
  const authStore = useAuthStore()

  if (!authStore.initialized) {
    await authStore.initializeAuth()
  }

  const currentUser = authStore.currentUser
  const path = to.path

  // 🔒 관리자 전용 처리
  if (path.startsWith('/admin')) {
    const publicPaths = ['/admin/welcome', '/admin/index', '/admin/autologin']
    const guestOnlyPaths = ['/admin/login']

    // ✅ 누구나 접근 가능한 경로
    if (publicPaths.some((p) => path.startsWith(p))) {
      return
    }

    // ✅ 로그인된 사용자가 guestOnly 접근 시 리디렉션
    if (currentUser && guestOnlyPaths.includes(path)) {
      return navigateTo('/admin/dashboard')
    }

    // ✅ 로그인 안된 사용자 → 로그인 페이지 접근 허용
    if (!currentUser && guestOnlyPaths.some((p) => path.startsWith(p))) {
      return
    }

    // ✅ 로그인 안된 사용자 → 보호된 관리자 페이지 접근 시 로그인 페이지로 이동
    if (!currentUser) {
      return navigateTo('/admin/login')
    }
  }
})
